import {
  FILTER_SHOW_FILTER,
  FILTER_UPDATE_FILTER,
  FILTER_UPDATE_INPUT_FILTER,
  FILTER_CLEAR_INPUT_FILTER
} from '../actions/filter.actions'
import { format } from 'date-fns'

const filterAudit = {
  startDate: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
  endDate: format(new Date(), 'yyyy-MM-dd HH:mm:ss')
}

const filterDefault = {
  open: false,
  filter: {}
}

const initState = {
  moduleName: '',
  audit: {
    open: false,
    filter: { ...filterAudit }
  },
  maintenance: { ...filterDefault },
  feed: { ...filterDefault },
  user: { ...filterDefault },
  lc: { ...filterDefault },
  class: { ...filterDefault },
  subject: { ...filterDefault },
  dr: { ...filterDefault },
  ul: { ...filterDefault },
  gantt: { ...filterDefault },
  drGroupedByLearningContinuum: { ...filterDefault },
  periodicalReport: { ...filterDefault },
  usersClass: { ...filterDefault },
  learningMatrix: { ...filterDefault },
  builderUsers: { ...filterDefault },
  surveyClassList: { ...filterDefault },
  assessmentReviewers: { ...filterDefault },
  assessmentStudentsList: { ...filterDefault },
  groupStudents: { ...filterDefault },
  surveyPreviewList: { ...filterDefault },
  assessmentMarking: { ...filterDefault },
  dataEntryAssessment: { ...filterDefault },
  dataEntryMyAssessment: { ...filterDefault },
  dataEntrySurvey: { ...filterDefault },
  dataEntryMySurvey: { ...filterDefault },
  analyticsUsers: { ...filterDefault },
  analyticsClasses: { ...filterDefault },
  analyticsCurriculumHistory: { ...filterDefault }
}

const filterReducer = (state = initState, action) => {
  const newState = { ...state }
  const { payload, type } = action

  switch (type) {
    case FILTER_SHOW_FILTER:
      newState.moduleName = payload.module
      if (newState[payload.module]) {
        newState[payload.module] = { ...newState[payload.module], open: payload.open }
      }
      break
    case FILTER_UPDATE_FILTER:
      newState.moduleName = payload.module
      if (newState[payload.module]) {
        if (payload.filter) {
          newState[payload.module] = { ...newState[payload.module], filter: { ...payload.filter } }
        } else {
          if (payload.module === 'audit') {
            newState[payload.module] = {
              ...newState[payload.module],
              filter: JSON.parse(JSON.stringify({ ...filterAudit }))
            }
          } else if (payload.module !== 'gantt') {
            newState[payload.module] = { ...newState[payload.module], filter: {} }
          }
        }
      }
      break
    case FILTER_UPDATE_INPUT_FILTER:
      newState.moduleName = payload.module
      if (newState[payload.module]) {
        const { name, value } = payload
        newState[payload.module] = {
          ...newState[payload.module],
          filter: { ...newState[payload.module].filter, [name]: value }
        }
      }
      break
    case FILTER_CLEAR_INPUT_FILTER:
      newState.moduleName = payload.module
      if (newState[payload.module]) {
        const { name } = payload
        if (newState[payload.module].filter[name]) {
          const newFilter = JSON.parse(JSON.stringify({ ...newState[payload.module].filter }))
          delete newFilter[name]
          if (action.payload.name === 'user') {
            delete newFilter.userId
          }
          if (action.payload.name === 'role') {
            delete newFilter.roleId
          }
          if (action.payload.name === 'module') {
            delete newFilter.action
          }
          newState[payload.module] = {
            ...newState[payload.module],
            filter: JSON.parse(JSON.stringify({ ...newFilter }))
          }
        }
      }
      break
    default:
      break
  }

  return newState
}

export default filterReducer
